import React from 'react'
import { Typography } from '@material-ui/core'
import { useIntl } from 'react-intl'

const NotificationMetricWithoutChannel = ({ isShow }) => {
  const { formatMessage } = useIntl()

  const text = formatMessage({
    id: 'notification.metrics.noChannel.label',
  })

  return (
    <>
      {isShow && (
        <div>
          <Typography>{text}</Typography>
        </div>
      )}
    </>
  )
}

export default NotificationMetricWithoutChannel
